import { crudActions } from "./CrudActions"

export default {
  ...crudActions("objectius"),
}
